import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ShopClientRealTimeControlOptionSetting } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopClientRealTimeControlOptionSetting';

import { 
    callShopClientRealTimeControlOptionSetting, 
    callEditShopClientRealTimeControlOptionSetting 
} from 'network/apis/shop/shopClientRealTimeControlOptionSetting';

// 매장 클라이언트 실시간 제어 옵션 정보 조회 사가 함수
function* loadShopClientRealTimeControlOptionSettingRequestSaga() {
    try {
        const manager = yield select(state => state.manager);

        const response = yield call(callShopClientRealTimeControlOptionSetting, manager.manager.shopGuid);

        yield put(actions.loadShopClientRealTimeControlOptionSettingRequestSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopClientRealTimeControlOptionSettingRequestFailure(error.message));
    }
}

// 매장 클라이언트 실시간 제어 옵션 정보 조회 사가 함수
function* editShopClientRealTimeControlOptionSettingRequestSaga() {
    try {
        const manager = yield select(state => state.manager);
        const shopClientRealTimeControlOptionSetting = yield select(state => state.shopClientRealTimeControlOptionSetting);

        const data = {
            paymentType: shopClientRealTimeControlOptionSetting.data.paymentType,
            usageTime: shopClientRealTimeControlOptionSetting.data.usageTime,
            isContentLimit: shopClientRealTimeControlOptionSetting.data.isContentLimit,
            gameTypeLimit: shopClientRealTimeControlOptionSetting.data.gameTypeLimit,
            gameHoleTypeLimit: shopClientRealTimeControlOptionSetting.data.gameHoleTypeLimit,
            playerCountLimit: shopClientRealTimeControlOptionSetting.data.playerCountLimit,
            drivingRangeTimeLimit: shopClientRealTimeControlOptionSetting.data.drivingRangeTimeLimit,
        };

        const response = yield call(callEditShopClientRealTimeControlOptionSetting, manager.manager.shopGuid, data);

        yield put(actions.editShopClientRealTimeControlOptionSettingRequestSuccess(response.data));

        alert('실시간 제어 옵션 수정이 완료되었습니다.');
    } catch(error) {
        yield put(actions.editShopClientRealTimeControlOptionSettingRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ShopClientRealTimeControlOptionSetting.LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST, loadShopClientRealTimeControlOptionSettingRequestSaga),
        takeLatest(ShopClientRealTimeControlOptionSetting.EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST, editShopClientRealTimeControlOptionSettingRequestSaga),
    ]);
}